import { atom, useAtom } from "jotai";
import { productPriceInfoAtoms } from "./headerHooks";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import usePopup from "./usePopup";

const priceInfoDataAtom = atom<IProduct["selling_prices"] | undefined>(
  undefined,
);

const useProductPriceInfoPopup = () => {
  const { handleOpenPopup, handleClosePopup, popupValue } = usePopup(
    productPriceInfoAtoms,
  );
  const [priceInfo, setPriceInfo] = useAtom(priceInfoDataAtom);

  const handleOpenProductPriceInfoPopup = (
    priceInfoData: IProduct["selling_prices"],
  ) => {
    handleOpenPopup(true);
    setPriceInfo(priceInfoData);
  };

  const handleCloseProductInfoPopup = () => {
    handleClosePopup();
    setPriceInfo(undefined);
  };

  return {
    popupValue,
    priceInfo,
    handleCloseProductInfoPopup,
    handleOpenProductPriceInfoPopup,
  };
};

export default useProductPriceInfoPopup;
